import React from 'react';
import InvoiceProductSection from './InvoiceProductSection';

const InvoiceProductSectionContainer = ({ items, ...props }) => {
  return <InvoiceProductSection {...props} items={items} />;
};

export default React.memo(InvoiceProductSectionContainer);
